import { useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { EmployeePayrollHistoryTab } from './EmployeePayrollHistoryTab'
import { ContractorPayrollHistoryTab } from './ContractorPayrollHistoryTab'
import { Card, CardColors, Tab, Text } from '@/ui'
import { TypographyStyles } from '@/styles'

export const PayrollHistory = () => {
  const [searchParams] = useSearchParams()

  const [activeIndex, setActiveIndex] = useState(
    searchParams.get('tab') === 'contractor' ? 1 : 0
  )

  const panes = useMemo(
    () => [
      {
        menuItem: 'Payroll History',
        render: () => <EmployeePayrollHistoryTab />,
      },
      {
        menuItem: 'Contractor Payment History',
        render: () => <ContractorPayrollHistoryTab />,
      },
    ],
    []
  )

  return (
    <Card color={CardColors.LEVEL_0}>
      <Text variant={TypographyStyles.H1}>Payroll History</Text>
      <br />
      <Tab
        panes={panes}
        defaultActiveIndex={activeIndex}
        onTabClick={(index) => setActiveIndex(index)}
      />
    </Card>
  )
}
